'use client'

import { useTranslations } from 'next-intl'

import { PassportEmailVerificationButton } from '@/features/verify-identity'
import { Notice } from '@/shared/ui'

export const PassportEmailVerification = () => {
  const t = useTranslations()

  return (
    <section className="bg-gray-0 rounded-lg p-8.5 text-center">
      <div className="mb-4">
        <Notice.Title className="mb-1.5 justify-center">
          {t('verification.no_korean_phone_title')}
        </Notice.Title>
        <p className="typo-label1-reading whitespace-break-spaces text-gray-500">
          {t('verification.no_korean_phone.description')}
        </p>
      </div>
      <PassportEmailVerificationButton />
    </section>
  )
}
